<template>
  <div>
      <div class="link" :class="{'show-info': isLink, 'go-bottom': !isLink}" style="font-size: 13px">
        <p class="link-title" v-if="!subMitType">
           {{isEnglish? feedbackMap[0].english : feedbackMap[0].chinese}} 
           <iconx type='guanbi1' size='20' @click.native="()=>changeLink(false)"/>
        </p>
        <p class="link-title" v-if="subMitType">
          <iconx type='fanhui' size='24'  v-if="subMitType"  style="display: inline-block"  @click.native="()=>subMitType=''"/>
          {{ submitTypeTitle }} 
          <iconx type='guanbi1' size='20' @click.native="()=>changeLink(false)"/>
        </p>
        <div class="link-content">
           <p v-show="!subMitType">{{isEnglish? feedbackMap[1].english : feedbackMap[1].chinese}}</p>
           <div class="link-flex-img" v-show="!subMitType">
             <div>
               <div>
                 <iconx type='ditu' color='rgb(19,150,220)'  @click.native="submitInfo('地图')"/>
               </div>
               <span>{{isEnglish? feedbackMap[2].english : feedbackMap[2].chinese}}</span>
              </div>
             <div>
               <div>
                 <iconx type='yuyin' color='rgb(255,184,44)'  @click.native="submitInfo('语音')"/>
               </div>
               <span>{{isEnglish? feedbackMap[3].english : feedbackMap[3].chinese}}</span>
             </div>
             <div>
               <div>
                 <iconx type='gongnengshengji' color='rgb(17,196,49)'  @click.native="submitInfo('功能')"/>
                </div>
                <span>{{isEnglish? feedbackMap[4].english : feedbackMap[4].chinese}}</span>
                </div>
             <div>
                <div>
                 <iconx type='qita' color='rgb(250,95,165)'  @click.native="submitInfo('其他')"/> 
                </div>
                <span>{{isEnglish? feedbackMap[5].english : feedbackMap[5].chinese}}</span>
              </div>
           </div>
           <div v-show="subMitType" style="submit-list">
              <div >
                <p style="text-align: left;" >{{isEnglish? feedbackMap[7].english : feedbackMap[7].chinese}}</p>
                <input type="text" :placeholder="isEnglish? feedbackMap[8].english : feedbackMap[8].chinese" v-model="mobile" :class="{'link-eng-input': isEnglish}">
              </div>
              <div>
                <p style="text-align: left;">{{isEnglish? feedbackMap[9].english : feedbackMap[9].chinese}}</p>
                <textarea rows="3" cols="20" type="textarea" :placeholder="isEnglish? feedbackMap[10].english : feedbackMap[10].chinese" style="height: 130px; padding: 18px 27px" v-model="desc" :class="{'link-eng-input': isEnglish}"></textarea>
              </div>
              <div>
                <p style="text-align: left;">上传图片</p>
                 <div class="add" @click="chooseType">
                    <div class="add-image" align="center">
                        <img class="icon-camera" src="@/static/imgs/upload.png" alt="">
                        <p class="font13">添加图片</p>
                    </div>
                </div>

              </div>
              <div class="add-img-list" v-show="imgList.length">
                <p class="font14">图片(最多3张，还可上传<span v-text="3-imgList.length"></span>张)</p>
                <ul class="img-list">
                    <li v-for="(url,index) in imgList" :key="index">
                        <img class="del" src="@/static/imgs/cha.png" @click.stop="delImg(index)"/>
                        <!-- <span class="del" @click.stop="delImg(index)">xxx</span > -->
                            <div class="app-bg">
                              <img :src="url.file.src">
                                <!-- <yd-lightbox-img class="app-bg" :original="url.file.src" ></yd-lightbox-img> -->
                            </div>
                        
                    </li>
              </ul>
</div>

           </div>
        </div>
        <div>

        </div>
        <p class="link-bottom" >
          <a :href="'tel:'+tourInfo.settings.phone" v-show="!subMitType"><i class="wack wack-dianhua8"></i>{{isEnglish? feedbackMap[6].english : feedbackMap[6].chinese}}</a>
          <a href="###" v-show="subMitType" @click="sumitOpinion">{{isEnglish? feedbackMap[11].english : feedbackMap[11].chinese}}</a>
        </p>
      </div>   
       <input @change="fileChange($event)" type="file" id="upload_file"  multiple style="display: none"/>
    <!-- <div class="dibuchose">
       
      <ul>
        <li class="paizhao" @click="captureImage()">拍照</li>
        <li class="paizhao" @click="galleryImg()">从相册选择</li>
        <li class="paizhao" @click="quxiao()">取消</li>
      </ul>
     
    </div> -->
  </div>
</template>
<script>
import * as constMap from '@/static/const.js'
import * as config from '@/api/api'
import iconx from './iconx'
 export default {
     data() {
         return {
            feedbackMap: constMap.feedbackDialogEnglishMap,
            isSubmit: false,
            subMitType: '',
            submitTypeTitle: '',
            typeEngMap: constMap.typeEnglishMap,
            mobile: '',
            desc: '',
            showFace: false,
            imgList: [],
            size: 0,
            limit:3, //限制图片上传的数量
            tempImgs:[],
            show1:true,
            allImgUrl:"",
            tourInfo:{}
         }
     },
      components: {
        iconx
    },
    watch: {
        isLink: {
            handler(val) {
                if(val) {
                    this.isSubmit = false
                    this.subMitType = ''
                }
            }
        }
    },
     props: {
       isLink: {
           type: Boolean,
           default: false
       },
       isEnglish: {
           type: Boolean,
           default: false
       }
     },
     created(){
        
this.tourInfo=JSON.parse(localStorage.getItem("tourInfo"))
     },
     methods: {
       

       submitInfo(type){
        this.isSubmit = true
        this.subMitType = type
        this.submitTypeTitle = this.isEnglish ? this.typeEngMap[type].english : this.typeEngMap[type].chinese
      },
      changeLink(val) {
        this.$emit('changeLink', val)
      },
      sumitOpinion(){
        let data = {
          type: constMap.typeMap[this.subMitType],
          mobile: this.mobile,
          desc: this.desc,
          imgs:this.allImgUrl,
          guide_id:config.AudioId
        }
        config.feedback(data).then(res => {
          if(res.data.success){
              this.subMitType = ''
              this.isSubmit = false
              this.imgList=[]
              this.$emit('successFeed')
          }
        })
      }, 
      chooseType(){
        document.getElementById('upload_file').click();
      },
      fileChange(el) {
          if (!el.target.files[0].size) return;
          this.fileList(el.target);
          el.target.value = ''
          console.log(el)
      },
      fileList(fileList) {
          let files = fileList.files;
          for (let i = 0; i < files.length; i++) {
              //判断是否为文件夹
              if (files[i].type != '') {
                  this.fileAdd(files[i]);
              } else {
                  //文件夹处理
                  this.folders(fileList.items[i]);
              }
          }
      },
            //文件夹处理
            folders(files) {
                let _this = this;
                //判断是否为原生file
                if (files.kind) {
                    files = files.webkitGetAsEntry();
                }
                files.createReader().readEntries(function (file) {
                    for (let i = 0; i < file.length; i++) {
                        if (file[i].isFile) {
                            _this.foldersAdd(file[i]);
                        } else {
                            _this.folders(file[i]);
                        }
                    }
                });

            },
            foldersAdd(entry) {
                let _this = this;
                entry.file(function (file) {
                    _this.fileAdd(file)
                })
            },
            fileAdd(file) {
                if (this.limit !== undefined) this.limit--;
                if (this.limit !== undefined && this.limit < 0) return;
                //总大小
                this.size = this.size + file.size;
                //判断是否为图片文件
                if (file.type.indexOf('image') == -1) {
                    this.$dialog.toast({mes: '请选择图片文件'});
                } else {
                    let reader = new FileReader();
                    let image = new Image();
                    let _this = this;
                    reader.readAsDataURL(file);
                    reader.onload = function () {
                        file.src = this.result;
                        image.onload = function(){
                            let width = image.width;
                            let height = image.height;
                            file.width = width;
                            file.height = height;
                            _this.imgList.push({
                                file
                            });
                            let data = new FormData();
                            data.append("file", file);
                            data.append("name", "test");
                            config.attachment(data).then(res=>{
                              // console.log(res)
                              if(res.data.success){
                              _this.allImgUrl=_this.allImgUrl+res.data.data[0].attachment+","

                              }
                              console.log(_this.allImgUrl)
                            })
                            // console.log( _this.imgList);
                        };
                        image.src= file.src;
                    }
                }
            },
            delImg(index) {
                this.size = this.size - this.imgList[index].file.size;//总大小
                this.imgList.splice(index, 1);
                if (this.limit !== undefined) this.limit = 6-this.imgList.length;
            },
      
    },
   
 }
</script>
<style lang="scss" scoped>
.show-info {
  top: 120px !important;
  transition: top .35s ease-in-out !important;
}
.go-bottom {
  top: -1000px !important;
  transition: top .25s ease-in-out !important;
}
.link {
  position: absolute;
  top: -500px;
  left: 50%;
  border-radius: 20px;
  transform: translateX(-50%);
  width: 288px;
  height: auto;
  display: block;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  z-index: 10000000000000000;
  overflow: hidden;
  background-color: #ffffff;
  .link-title {
    text-align: center;
    width: 100%;
    height: 46px;
    line-height: 46px;
    font-size: 19px;
    color: rgb(91, 91, 91);
    position: relative;
  }
  .link-eng-input {
    font-size: 10px;
    padding-left: 12px !important;
  }
  .link-content {
    width: 80%;
    margin: 0 auto;
    height: 200px !important;
    flex: 1;
    background-color: rgba(255, 255, 255, 0.9);
    p {
      text-align: center;
      color: rgb(144, 144, 144);
      font-size: 11px;
    }
    .link-flex-img {
      width: 100%;
      height: 200px;
      display: flex;
      justify-content: space-around;
      flex-direction: row;
      flex-wrap: wrap;
      text-align: center;
      padding-top: 10px;
      box-sizing: border-box;
      > div {
        float: left;
        width: 50%;
        height: 50%;
        i,
        span {
          display: block;
          margin: 0 auto;
        }
        > div {
          width: 63px;
          height: 63px;
          background-color: rgb(59, 60, 78);
          margin: 0 auto;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        i {
          font-size: 34px !important;
        }
        span {
          line-height: 28px;
          height: 28px;
          font-size: 13px;
        }
      }
    }
  }
  input,
  textarea {
    width: 100%;
    height: 28px;
    border-radius: 20px;
    border: 1px solid #f4f4f4;
    padding-left: 24px;
    display: block;
    margin: 0 auto;
    box-sizing: border-box;
  }
  input:focus {
    border: 1px solid #f4f4f4;
    outline: none;
  }
  textarea:focus {
    border: 1px solid #f4f4f4;
    outline: none;
  }
  .link-bottom {
    height: 50px;
    a {
      display: block;
      margin: 0 auto;
      width: 230px;
      height: 36px;
      line-height: 36px;
      border-radius: 22px;
      text-align: center;
      font-size: 16px;
      color: rgb(114, 64, 11);
      background-color: rgb(255, 221, 2);
    }
    i {
      display: inline-block;
      font-size: 16px !important;
      margin-right: 9px;
    }
  }

  .add {
        display: inline-block;
        margin-bottom: 20px;
        height: 80px;
        width: 100px;
    }
    .add>div{
      width: 100%;
      height: 100%;
    }

    .add-image {
        padding-top: 15px;
        margin-left: 10px;
        box-sizing: border-box;
        width: 80px;
        top: 20px;
        height: 80px;
        border: 1px dashed rgba(0, 0, 0, .2);
    }

    .add-image .icon-camera {
        font-size: 24px;
    }
    .add-image img{
      width: .4rem;
      height: auto;
    }
    .img-list {
        overflow: hidden;
        display: flex;
    }

    .img-list > li {
        float: left;
        width: 33%;
        height: auto;
        text-align: center;
       
        margin-left: 1%;
        margin-top: 1%;
        position: relative;
        list-style: none;
        position: relative;
        >img{
          position: absolute;
          top: 2px;
          right: 2px;
          background: #fff;
          width: 25px;
          height: auto;
        }
    }

    

    .img-list > li > .app-bg {
        width: 100%;
        height: 100%;
        img{
          width: 100%;
          height: 90%;
        }
    }
 
  
}
 .dibuchose{
   width: 100%;
   height: auto;
    position: fixed;
    bottom: 0;
    

    z-index: 999999999 !important;
    font-size: 14px;
    text-align: center;
    color: #000;
    li{
      padding: 10px 0;
      box-sizing: border-box;
      border-bottom: 1px solid #ccc;
      background: #fff;

    }
    li:first-child{
      border-radius: 10px;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }
    li:last-child{
      margin-top: 5px;
      border: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/feedback.vue